import { render } from "./ViewCoachingGroupReports.vue?vue&type=template&id=ea415386&scoped=true"
import script from "./ViewCoachingGroupReports.vue?vue&type=script&lang=js"
export * from "./ViewCoachingGroupReports.vue?vue&type=script&lang=js"

import "./ViewCoachingGroupReports.vue?vue&type=style&index=0&id=ea415386&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea415386"]])

export default __exports__